import { t } from '@lingui/core/macro';
import { createFileRoute } from '@tanstack/react-router';

import { TeamMembersManager } from '../-components/team-members-manager';
import { teamMembersQueryOptions } from '../-utils/team-settings-query';
import { SettingsSection } from '../../settings/-components/settings-section';
import { SETTINGS_HELP } from '../../settings/-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/organization-settings/team/members',
)({
  loader: ({ context }) =>
    context.queryClient.prefetchQuery(
      teamMembersQueryOptions(context.activeDashboard.team ?? ''),
    ),
  component: TeamMembersPage,
  head: () => ({ meta: [{ title: t`Team members` }] }),
});

function TeamMembersPage() {
  const { activeDashboard } = Route.useRouteContext();
  return (
    <SettingsSection
      title={t`Team members`}
      description={t`Who's on this team and what they can do.`}
      helpUrl={SETTINGS_HELP.teams}
    >
      <TeamMembersManager teamId={activeDashboard.team ?? ''} />
    </SettingsSection>
  );
}
